<template>
  <svg class="MobileIndicator" width="350" height="88" viewBox="0 0 350 88">
    <g @click="showPopupAndHideNotification()" class="indicatorIcon">
      <circle cx="316" cy="39" r="30" fill="#09f"/>
      <circle cx="316" cy="39" r="21.7" fill="#fff"/>
      <path fill="#000" d="M316 34.5a2.6 2.6 0 1 1 0-5.2 2.6 2.6 0 0 1 0 5.2zm0 16.7c-.7 0-1.3-.3-1.8-1-.5-.5-.8-1.3-.8-2.2v-7.2c0-.8.3-1.6.8-2.2.5-.6 1.1-1 1.8-1s1.4.4 1.9 1 .7 1.4.7 2.2v7.2c0 .9-.2 1.7-.7 2.3-.5.6-1.2 1-1.9 1z"/>
    </g>
    <g v-if="text" class="notification" :class="{ notificationShowing }">
      <g @click="showPopupAndHideNotification()" class="notificationMessage">
        <path fill="#fff" d="M36 8.5a8 8 0 0 0-8 8v44a8 8 0 0 0 8 8h228a8 8 0 0 0 8-8v-16l5.3-5.3c.4-.4.4-1 0-1.4l-5.3-5.3v-16a8 8 0 0 0-8-8H54z"/>
        <text class="text">
          <tspan x="39.6" y="33.5">{{ textLines[0] }}</tspan>
          <tspan x="39.6" y="51.8">{{ textLines[1] }}</tspan>
        </text>
      </g>
      <g transform="translate(341, 17)" class="notificationBlip">
        <circle r="8" fill="#f44242"/>
        <path d="M-1.4 -2v-1.1h2v6.2h-1.2V-2z" fill="#f0f0f3"/>
      </g>
      <g @click="dismissNotification()" class="notificationClose">
        <circle cx="11" cy="14" r="9" fill="#687882"/>
        <path fill="#fff" d="m15.4 10.5-3.5 3.5 3.5 3.5-1 .9-3.4-3.5-3.5 3.5-.9-1 3.5-3.4-3.5-3.5 1-.9 3.4 3.5 3.5-3.5z"/>
      </g>
    </g>
  </svg>
</template>

<script>
// Break a string into an array of lines of length no longer than max. length, splitting on word breaks.
function breakLines(text, maxLength) {
  var currentLine = ''
  const result = []
  const wordMatches = text.matchAll(/[^ ][^ -]*[ -]?/g)
  const words = Array.from(wordMatches, ([value]) => value)
  for (const word of words) {
    if ((currentLine + word).trim().length > maxLength) {
      result.push(currentLine.trim())
      currentLine = word
    }
    else {
      currentLine += word
    }
  }
  result.push(currentLine.trim())
  return result
}

export default {
  props: {
    text: String,
    notificationActivated: Boolean,
    showPopup: Function,
  },
  data() {
    return {
      notificationHidden: false,
    }
  },
  computed: {
    textLines() {
      const maxLineLength = 35
      return this.text ? breakLines(this.text, maxLineLength) : []
    },
    notificationShowing() {
      return (
        this.notificationActivated &&
        !this.notificationHidden &&
        sessionStorage['PromoPopupNotification'] !== 'dismissed'
      )
    }
  },
  methods: {
    dismissNotification() {
      if (typeof window !== undefined) {
        sessionStorage['PromoPopupNotification'] = 'dismissed'
      }
      this.notificationHidden = true
    },
    showPopupAndHideNotification() {
      this.notificationHidden = true
      this.showPopup()
    }
  },
}
</script>

<style scoped>

.MobileIndicator {
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.25));
}

.text {
  font-weight: 500;
  font-size: 12px;
  line-height: 1.5;
  fill: #3b3f44;
}

.notification {
  pointer-events: none;
}

.notification.notificationShowing {
  pointer-events: all;
}

.notificationClose, .notificationBlip {
  opacity: 0;
  transition: opacity 0.2s 0.2s;
}

.notificationShowing .notificationClose, .notificationShowing .notificationBlip {
  opacity: 1;
}

.notificationMessage {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.2s ease-out;
}

.notificationShowing .notificationMessage {
  opacity: 1;
  transform: none;
}
</style>
